import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit, OnChanges {

  @Input() map: any;
  @Input() type: string;
  @Input() layersList: any;
  @Input() labelStrings: any;
  @Input() selectedIcon: any;
  @Input() blockNumber: number;
  @Input() fullScreenView: any;
  @Input() fullScreenMapName: any;
  @Output() posNum = new EventEmitter<any>();
  @Output() closeStatus = new EventEmitter<boolean>();
  @Output() collapseEvent = new EventEmitter<boolean>();
  @Output() activeSideMenu = new EventEmitter<boolean>();
  @Input() sidebarComponent:any

  activeMenu: string;
  activeMenuClass: string;
  componentName: string;
  moduleName: string;
  isActual: string;
  time: string;
  logoFlag = true;
  disabledMapsListOfCyclone = [];
  collapseMenu = false;
  currentActive:string
  currentModule: string;
  showHome = true;

  activeMenuObj ={
    "extremeweather":false,
    "observedweather":false,
    "heatwatch":false,
    "coldwatches":false,
    "cyclone":false,
    "drought":false,
    "nowcastweather":false,
    "floodforecast":false,
    "drinkingwaterstress":false,
    "lightning":false,
    "webeoc":false,
    "alert":false,
    "rainfallActual":false,
    "weatherdata" : false,
    'thunderstorms':false,
    'weatherforecast':false,
    'disastermonitoring':false,
    'fogwatch': false,
  };

  menus = [
    // { icon: 'mi-weather', title: 'Observed Weather', link: 'observedweather/rainfall-actual/24', type: 'observedweather' },
    // { icon: 'mi-temperature', title: 'Heat Watch', link: 'heatwatches/heatwave', type: 'heatwave' },
    { icon: 'mi-heat_wave', title: 'NHIP', link: 'nhip-dashboard/nhip', type: 'nhip' },
    // { icon: 'mi-cold-_wave', title: 'Cold Watch', link: 'coldwatches/coldwave', type: 'coldwave' },
    // { icon: 'fas fa-cloud', title: 'Fog', link: 'fogwatch/fog', type: 'fog' },
    // { icon: 'mi-weather1', title: 'Weather Forecast', link: 'weatherforecast/rainfall-forecast', type: 'weatherforecast' },
    // { icon: 'mi-nowcast', title: 'Nowcast', link: 'nowcastweather/forecast', type: 'nowcastweather' },
    // { icon: 'mi-weather_alert', title: 'Alert', link: 'alert/gis', type: 'alert'},
    // { icon: 'mi-thunderstrom', title: 'Thunderstorm', link: 'thunderstorms/thunderstorm', type:'thunderstorm'},
    // { icon: 'fas fa-cloud-showers-heavy', title: 'Disaster Monitoring', link: 'disastermonitoring/monitor', type: 'monitor'},
    // { icon: 'mi-cyclones', title: 'Cyclone', link: 'cyclone/forecast', type: 'cyclone' },
    // {icon:'mi-drought', title:'Drought', link: '/drought/rainfall/24'},
    // {icon:'mi-flow-forecast', title:'Flow Forecast', link: '/flowforecast/rainfall/24'},
    // {icon:'mi-drinking-water', title:'Drinking Water', link: '/drinkingwater/rainfall/24'},
    // { icon: 'mi-weather', title: 'Weather Forecast', link: 'extremeweather/rainfall/24', type: 'extremeweather' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/nowcast/24', type: 'nowcastweather' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/nowcast', type: 'nowcast' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/radar-forecast', type: 'radarforecast' },
    // { icon: 'mi-flow-forecast', title: 'Nowcast Flood Alerts', link: 'floodforecast/gis', type: 'floodforecast'},
    // { icon: 'mi-drought', title: 'Drought', link: 'drought/gis', type: 'drought' },
    // { icon: 'mi-drinking-water', title: 'Drinking Water Stress', link: 'drinkingwaterstress/gis', type:'drinkingwaterstress'},
    // { icon: 'fas fa-bolt', title: 'Lightning', link: 'lightning/gis', type:'lightning'},
    // { icon: 'fas fa-cloud-download-alt', title: 'Weather Data', link: 'weatherdata/mis', type: 'weatherdata'},
  ];
  lang: string;
  stateUrlId: string;
  currentLatLong={};

  constructor(private router: Router, private route: ActivatedRoute, private utils: UtilsService,) {
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    ProjConstants.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId];
    const STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId];
    if (STATENAME == 'ANDHRA PRADESH') {
      this.logoFlag = true;
    } else {
      this.logoFlag = false;
    }
  }


  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    Object.keys(this.activeMenuObj).forEach(key=>{
      this.activeMenuObj[key] = this.router.url.split('/')[1] == key ? true:false;
    })
    this.menus.forEach(element => {
      if (this.router.url.split('/')[1] == element.link.split('/')[1]) {
        // this.handleMenuClick(element)
        this.moduleName = this.router.url.split('/')[1];
      }
    });
    console.log(this.moduleName, "Module Name");

    const componentArray = this.router.url.split('/')[2].split('-');
    if (componentArray.length > 1 && componentArray[1] == 'actual') {
      this.isActual = 'true';
    } else {
      this.isActual = 'false';
    }
    this.utils.disabledMaps.subscribe(res => {
      this.disabledMapsListOfCyclone = res;
    });
    this.currentModule = this.router.url.split('/')[1];
    this.utils.getShowHomeButton().subscribe(val=>{
      this.showHome = val;
    })
  }

  ngOnChanges(change: SimpleChanges) {

    //this.router.events.subscribe(Event=>{
     // console.log('Event here',Event['snapshot']['_routerState'])
    //})

    if (!isNullOrUndefined(change.blockNumber) && change.blockNumber.currentValue !== change.blockNumber.previousValue) {
      this.blockNumber = change.blockNumber.currentValue;
    }
    if (!isNullOrUndefined(change.type) && change.type.currentValue !== change.type.previousValue) {
      this.menus.forEach(menu => {
        if (menu.type === change.type.currentValue) {
          this.handleMenuClick(menu);
        }
        else if(menu.type == 'heatwave' && change.type.currentValue == "heatindex"){
          this.handleMenuClick(menu);
        }
      });
    }
  }

  sidemenuCollapse() {
    this.collapseMenu = !this.collapseMenu
    this.collapseEvent.emit(this.collapseMenu);
  }

  collapseActive: boolean = false;

  activeMenuCollapse(value) {
    this.collapseActive = value;
    if(this.moduleName === 'drinkingwaterstress') {
      this.collapseActive = false;
    }
    this.activeSideMenu.emit(this.collapseActive);
  }

    handleMenuClick(menu): void {

    console.log("Menu", menu);

    // currentrouteloc.
    this.componentName = this.router.url.split('/')[2];
    this.moduleName = this.router.url.split('/')[1];
    this.time = this.route.snapshot.paramMap.get('time');
    const id = this.route.snapshot.paramMap.get('id');
    const link = menu.link + '/' + id;
    if (menu.link.split('/')[0] != this.moduleName) {
      console.log("link.split('/')", link.split('/'));

      this.router.navigate(link.split('/'), );
    }
     else {
      // if (isNullOrUndefined(this.activeMenu) || this.activeMenu != menu.title) {
      //   this.currentActive = menu.title;
      //   this.activeMenu = menu.title;
      //   this.activeMenuClass = 'active';
      //   this.activeMenuCollapse(true);
      // } else if (!isNullOrUndefined(this.activeMenu) && this.activeMenu == menu.title) {
      //   if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
      //     // alert('Please select appropriate number of maps to display');
      //   } else {
      //     if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
      //       this.closeStatus.emit(true);
      //     }
      //     this.activeMenu = null;
      //     this.activeMenuClass = '';
      //     this.activeMenuCollapse(false);
      //   }
      // }
      if (!this.activeMenu || this.activeMenu !== menu.title) {
        // Show sidebar for selected menu item
        this.currentActive = menu.title;
        this.activeMenu = menu.title;
        this.activeMenuClass = 'active';
        this.activeMenuCollapse(true);
      } else if (this.activeMenu === menu.title) {
        // Hide sidebar if the same menu item is clicked again
        if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
          // alert('Please select appropriate number of maps to display');
        } else {
          if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
            this.closeStatus.emit(true);
          }
          this.activeMenu = null;
          this.activeMenuClass = '';
          this.activeMenuCollapse(false);
        }
      }
      if (menu.title === 'Lightning') {
        this.closeStatus.emit(true);
        this.activeMenu = null;
        this.activeMenuClass = '';
        this.activeMenuCollapse(false);
      }
      if(this.componentName == 'forecast' || this.componentName == 'radar-forecast'){
        // this.closeStatus.emit(true);
        // this.activeMenu = null;
        // this.activeMenuClass = '';
        // this.activeMenuCollapse(false);
      }
      // this.router.navigate([this.moduleName, this.componentName, this.time]);
    }
    // this.currentActive = this.route['_routerState']['snapshot']['url'].split('/').splice(1)[0]
    // console.log('current Route',this.route['_routerState']['snapshot']['url'].split('/').splice(1)[0])

  }

  closeMenu() {
    if (this.activeMenu === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
      alert('Please select appropriate number of maps to display');
    } else {
      if (this.activeMenu === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
        this.closeStatus.emit(true);
      }
      this.activeMenuClass = '';
      this.activeMenuCollapse(false);
      this.activeMenu = null;
    }
  }

  sendPlayPos(event: any) {
    this.posNum.emit(event);
  }

  getActive(comp){
    // console.log("comp", comp);

    return this.activeMenuObj[comp.link.split("/")[0]];
  }

  goHome() {
    console.log(this.utils.getDeviceType())
    this.currentLatLong = this.utils.getCurrentLatLongFromLS();
    console.log(this.currentLatLong)
    this.router.navigate(['landing-page'])
    // this.router.navigate(['/'])
  }

  isMobile(){
    return this.utils.getDeviceType() == "mobile";
  }

  gotoWebeocPortal(){
    this.router.navigate(['webeocportal']);

  }
  gotostateReport(){
    this.router.navigate(['statereport']);

  }
}
